import router from '@/router'
import store from '@/store'
import { getToken } from '@/utils/cookie'

const whiteList = ['/login']

router.beforeEach((to, from, next) => {
  store.dispatch('CreateMenu', to.matched)
  if (getToken()) {
    if (store.state.permission.menuFirst.length === 0) {
      store.dispatch('CreateRouter').then(() => {
        router.addRoutes(store.state.permission.addRouters)
      }).then(() => {
        next({ ...to, replace: true })
      })
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }
})



// WEBPACK FOOTER //
// ./src/permission.js